/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Branch_Off_LoadingInputs */

const es_chat_branch_off_loading = /** @type {(inputs: Chat_Branch_Off_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Creando bifurcación...`)
};

const en_chat_branch_off_loading = /** @type {(inputs: Chat_Branch_Off_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Creating branch...`)
};

/**
* | output |
* | --- |
* | "Creating branch..." |
*
* @param {Chat_Branch_Off_LoadingInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const chat_branch_off_loading = /** @type {((inputs?: Chat_Branch_Off_LoadingInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Branch_Off_LoadingInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_chat_branch_off_loading(inputs)
	return en_chat_branch_off_loading(inputs)
});
export { chat_branch_off_loading as "chat.branch_off.loading" }